// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_gP","advertDetailContacts__header":"c-l_gQ"};